import { createSlice } from '@reduxjs/toolkit';
import { ResponseApi } from '../BaseApi';

/*
Author : Arman Ali
Module: Zone
github: https://github.com/Arman-Arzoo
*/

// slice to manage payroll state
const employeePayrollSlice = createSlice({
    name: 'employeePayRoll',
    initialState: {
        // employee state
        getAllSelectedEmployees: [],
        addEmployeesToListPayroll: {},
        deleteEmployeesToListPayroll: {},
        //export attendance
        createAttendanceExcelReport: {},
        // device state
        getAllSelectedDevice: [],
        addDeviceToListPayroll: {},
        deleteDeviceToListPayroll: {},
        getAttendanceDepartments: {},
        createAttendanceDepartment: {},
        updateAttendanceDepartment: {},

        // email setting
        getEmailSetting: [],
        updateEmailSetting: {},
        getColorAttendance: {},
        getEmailColor: {},

        // change time and checkbox
        changeTimeAndSelectedDaysUpdate: {},
        //update attendance color
        updateAttendanceColor: {},
        removeEmployeeAttendance: false,
        removeDeviceAttendance: false,
    },
    reducers: {
        ClearDeleteEmployeesToListPayroll: (state, action) => {
            state.removeEmployeeAttendance = false;
        },
        ClearDeleteDeviceToListPayroll: (state, action) => {
            state.removeDeviceAttendance = false;
        },
    },
    extraReducers: {
        'employeePayRoll/getColorAttendance/fulfilled': (state, action) => {
            state.getColorAttendance = ResponseApi(action.payload);
        },
        'employeePayRoll/getEmailColor/fulfilled': (state, action) => {
            state.getEmailColor = ResponseApi(action.payload);
        },
        'employeePayRoll/getAllSelectedEmployees/fulfilled': (state, action) => {
            state.getAllSelectedEmployees = ResponseApi(action.payload);
        },
        'employeePayRoll/addEmployeesToListPayroll/fulfilled': (state, action) => {
            state.addEmployeesToListPayroll = ResponseApi(action.payload);
        },
        //create attendance report
        'employeePayRoll/createAttendanceExcelReport/fulfilled': (state, action) => {
            const {
                data: { data },
                status,
            } = action.payload || {};
        },

        'employeePayRoll/createSimpleAttendanceExcelReport/fulfilled': (state, action) => {
            const {
                data: { data },
                status,
            } = action.payload || {};
        },
        'employeePayRoll/createAttendancePDFReport/fulfilled': (state, action) => {
            const {
                data: { data },
                status,
            } = action.payload || {};
        },

        'employeePayRoll/createSimpleAttendancePDFReport/fulfilled': (state, action) => {
            const {
                data: { data },
                status,
            } = action.payload || {};
        },
        //delete employees to list payroll
        'employeePayRoll/deleteEmployeesToListPayroll/fulfilled': (state, action) => {
            state.deleteEmployeesToListPayroll = ResponseApi(action.payload);
        },

        // device payroll slice
        'employeePayRoll/getAllSelectedDevice/fulfilled': (state, action) => {
            state.getAllSelectedDevice = ResponseApi(action.payload);
        },
        'employeePayRoll/addDeviceToListPayroll/fulfilled': (state, action) => {
            state.addDeviceToListPayroll = ResponseApi(action.payload);
        },
        'employeePayRoll/deleteDeviceToListPayroll/fulfilled': (state, action) => {
            state.deleteDeviceToListPayroll = ResponseApi(action.payload);
        },
        'employeePayRoll/getAttendanceDepartments/fulfilled': (state, action) => {
            state.getAttendanceDepartments = ResponseApi(action.payload);
        },
        'employeePayRoll/createAttendanceDepartment/fulfilled': (state, action) => {
            state.createAttendanceDepartment = ResponseApi(action.payload);
        },
        'employeePayRoll/updateAttendanceDepartment/fulfilled': (state, action) => {
            state.updateAttendanceDepartment = ResponseApi(action.payload);
        },

        // email setting payroll slice
        'employeePayRoll/getEmailSetting/fulfilled': (state, action) => {
            state.getEmailSetting = ResponseApi(action.payload);
        },
        'employeePayRoll/updateEmailSetting/fulfilled': (state, action) => {
            state.updateEmailSetting = ResponseApi(action.payload);
        },
        // change the time or checkbox payroll
        'employeePayRoll/changeTimeAndSelectedDaysUpdate/fulfilled': (state, action) => {
            state.changeTimeAndSelectedDaysUpdate = ResponseApi(action.payload);
        },
        // update attendance color
        'employeePayRoll/updateAttendanceColor/fulfilled': (state, action) => {
            state.updateAttendanceColor = ResponseApi(action.payload);
        },
        // remove device
        'employeePayRoll/removeDeviceAttendance/fulfilled': (state, action) => {
            state.removeDeviceAttendance = ResponseApi(action.payload);
        },
        // remove employee
        'employeePayRoll/removeEmployeeAttendance/fulfilled': (state, action) => {
            state.removeEmployeeAttendance = ResponseApi(action.payload);
        },
    },
});

export const { ClearDeleteEmployeesToListPayroll, ClearDeleteDeviceToListPayroll } = employeePayrollSlice.actions;

export default employeePayrollSlice.reducer;
